import axios from 'axios';
import { API_BASE_URL } from './config';

/**
 * Get all brands available to the current user
 * @returns {Promise<Array>} List of brands
 */
export const getAvailableBrands = async () => {
  try {
    console.log('[brandService] Fetching available brands from:', `${API_BASE_URL}/brands/me`);
    const response = await axios.get(`${API_BASE_URL}/brands/me`, {
      withCredentials: true
    });
    console.log('[brandService] Available brands response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[brandService] Error fetching available brands:', error);
    // If user is not authenticated (401), return empty array instead of throwing
    if (error.response && error.response.status === 401) {
      console.log('[brandService] User not authenticated (401) - returning empty brands list');
      return [];
    }
    console.error('[brandService] Unexpected error:', error.message);
    throw error;
  }
};

/**
 * Get the current active brand with Mautic credentials
 * @returns {Promise<Object>} Current brand object
 */
export const getCurrentBrand = async () => {
  try {
    console.log('[brandService] Fetching current brand from:', `${API_BASE_URL}/brands/current`);
    const response = await axios.get(`${API_BASE_URL}/brands/current`, {
      withCredentials: true
    });
    console.log('[brandService] Current brand response:', response.data);
    return response.data;
  } catch (error) {
    console.error('[brandService] Error fetching current brand:', error);
    // Don't throw error if not authenticated or no brand is set, just return null
    if (error.response && (error.response.status === 401 || error.response.status === 404)) {
      console.log('[brandService] User not authenticated or no brand set (401/404) - returning null');
      return null;
    }
    console.error('[brandService] Unexpected error:', error.message);
    throw error;
  }
};

/**
 * Switch to a different brand
 * @param {number} brandId - The ID of the brand to switch to
 * @returns {Promise<Object>} The new current brand object
 */
export const switchBrand = async (brandId) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/brands/switch/${brandId}`,
      {},
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    console.error('Error switching brand:', error);
    throw error;
  }
};

/**
 * Get all brands with details (for displaying in UI)
 * @returns {Promise<Array>} List of brands with full details
 */
export const getAllBrandsWithDetails = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/brands/all`, {
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching all brands:', error);
    throw error;
  }
};

